import { userReducer } from "../modules/user/reducer";
import { combineReducers, configureStore } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  user: userReducer,
});

export const store = configureStore({ reducer: rootReducer });
